const store = {
    namespaced: true,
    state() {
        return {
            complaints: [],

            postSeo: null,
            post: null,
        };
    },
    getters: {
        complaints: state => state.complaints,

        postSeo: state => state.postSeo,
        post: state => state.post,
    },
    mutations: {
        SET_COMPLAINTS: (state, item) => (state.complaints = item),

        SET_POST_SEO: (state, item) => (state.postSeo = item),
        SET_POST: (state, item) => (state.post = item),
    },
    actions: {
        editPost: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'PATCH',
                url: `/api/adverts/${data.slug}/`,
            });
        },
        fetchPostData: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/general/v2/product/${data.slug}`,
                });
                commit('SET_POST', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        fetchPostSeo: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/api/advert-title/${data.slug}`,
                });
                if (res.data.title) commit('SET_POST_SEO', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        reportPost: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'post',
                    url: `/api/complaint/`,
                    data: {
                        category: data.categoryId,
                        body: data.message,
                        advert: data.postId,
                    },
                });
            } catch (error) {
                console.dir(error);
            }
        },
        fetchReportCases: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/complaint-categories/`,
                });
                commit('SET_COMPLAINTS', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
